(function () {
  function openMayekooPrivacyPrefs(event) {
    if (event) event.preventDefault();

    function tryOpen() {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        banner.showPreferences();
        return true;
      }
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.showPreferences === 'function') {
        privacy.showPreferences();
        return true;
      }
      var manage = document.querySelector(
        '#shopify-pc__banner__btn-manage-prefs, .shopify-pc__banner__btn-manage-prefs, #shopify-pc__prefs__header-manage, button[aria-controls="shopify-pc__prefs"]'
      );
      if (manage) {
        manage.click();
        return true;
      }
      var dialog = document.querySelector('#shopify-pc__prefs, #shopify-pc__prefs__dialog');
      if (dialog) {
        dialog.removeAttribute('hidden');
        if (dialog.showModal) {
          try {
            dialog.showModal();
          } catch (error) {
            dialog.setAttribute('open', '');
          }
        } else {
          dialog.style.display = 'block';
        }
        return true;
      }
      return false;
    }

    if (tryOpen()) return;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        window.setTimeout(tryOpen, 80);
      });
    }
  }

  function setStatus(form, type, heading, body) {
    var status = form.querySelector('[data-mk-nl-status]');
    if (!status) return;
    status.hidden = false;
    status.className = 'mk-nl-status mk-nl-status--' + type;
    status.innerHTML = '<strong>' + heading + '</strong> ' + body;
  }

  function formCopy(form, key, fallback) {
    return form.getAttribute(key) || fallback;
  }

  function markSuccess(form) {
    form.setAttribute('data-submitted', 'true');
    setStatus(
      form,
      'success',
      formCopy(form, 'data-mk-msg-success-h', 'Check your inbox.'),
      formCopy(form, 'data-mk-msg-success-b', 'Please confirm your subscription to complete your signup.')
    );
    var fields = form.querySelector('.mk-nl-fields');
    if (fields) fields.hidden = true;
  }

  function bindForms() {
    var forms = document.querySelectorAll('[data-mk-klaviyo-fallback]');
    if (!window.KlaviyoSubscribe) return false;
    forms.forEach(function (form) {
      if (form.getAttribute('data-mk-klaviyo-bound') === 'true') return;
      form.setAttribute('data-mk-klaviyo-bound', 'true');
      window.KlaviyoSubscribe.attachToForms('#' + form.id, {
        hide_form_on_success: true,
        success: function () {
          markSuccess(form);
        },
        extra_properties: {
          $source: 'Mayekoo footer suite',
          $method_type: 'Klaviyo Form',
          $method_id: 'footer-suite'
        }
      });
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var privacy = event.target.closest('[data-mk-privacy-prefs]');
    if (privacy) openMayekooPrivacyPrefs(event);
  });

  function preservePreviewOnContactForms() {
    var params = new URLSearchParams(window.location.search);
    var preview = params.get('preview_theme_id');
    if (!preview) return;
    document.querySelectorAll('form.mk-contact-form').forEach(function (form) {
      if (form.getAttribute('data-mk-preview-bound') === 'true') return;
      form.setAttribute('data-mk-preview-bound', 'true');
      form.addEventListener('submit', function () {
        try {
          var url = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
          url.searchParams.set('preview_theme_id', preview);
          form.setAttribute('action', url.pathname + url.search + (url.hash || ''));
        } catch (error) {}
      });
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mk-klaviyo-fallback]');
    if (!form) return;
    var email = form.querySelector('input[type="email"]');
    var value = email && email.value ? email.value.trim() : '';
    if (!value) {
      event.preventDefault();
      setStatus(form, 'error', formCopy(form, 'data-mk-msg-required', 'Please enter your email address.'), '');
      if (email) email.focus();
      return;
    }
    if (email && !email.checkValidity()) {
      event.preventDefault();
      setStatus(form, 'error', formCopy(form, 'data-mk-msg-invalid', 'Please enter a valid email address.'), '');
      email.focus();
      return;
    }
    if (form.getAttribute('data-mk-klaviyo-bound') === 'true') return;
    event.preventDefault();
    setStatus(form, 'error', formCopy(form, 'data-mk-msg-error', 'Something went wrong. Please try again.'), '');
  });

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    preservePreviewOnContactForms();
    if (bindForms()) return;
    var script = document.querySelector('script[src*="klaviyo_subscribe.js"]');
    if (script) {
      script.addEventListener('load', bindForms);
      window.setTimeout(bindForms, 1200);
    }
  });
})();
